"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EEPersonalId = void 0;
const config_1 = require("../../config");
const util_1 = require("../../util");
const dayjs = require("dayjs");
class EEPersonalId {
    constructor(id) {
        this.PERSONAL_ID_LENGTH = 11;
        this.id = typeof id === 'string' ? id : String(id);
    }
    isValid() {
        const birthdayStr = `${this.getBirthFullYear()}-${this.getBirthMonth()}-${this.getBirthDay()}`;
        const isValidBirthday = (0, util_1.isValidDate)(birthdayStr, 'YYYY-M-D');
        const isValidControlNumber = this.getControlNumber() === this.generateControlNumber();
        const isValidLength = this.id.length === this.PERSONAL_ID_LENGTH;
        return isValidBirthday && isValidControlNumber && isValidLength;
    }
    getGender() {
        const firstNumber = Number(this.id.charAt(0));
        if (firstNumber < 1 || firstNumber > 6) {
            throw new Error('Unknown gender');
        }
        if (firstNumber % 2) {
            return config_1.CustomerGender.Male;
        }
        return config_1.CustomerGender.Female;
    }
    getBirthdayAsString(format = 'YYYY-MM-DD') {
        return dayjs(`${this.getBirthFullYear()}-${this.getBirthMonth()}-${this.getBirthDay()}`, 'YYYY-M-D').format(format);
    }
    getBirthShortYear() {
        return parseInt(this.id.substring(1, 3));
    }
    getBirthDay() {
        return parseInt(this.id.substring(5, 7).replace(/^0/, ''));
    }
    getBirthMonth() {
        return parseInt(this.id.substring(3, 5).replace(/^0/, ''));
    }
    getBirthdayDate() {
        return new Date(this.getBirthFullYear(), this.getBirthMonth() - 1, this.getBirthDay());
    }
    getBirthFullYear() {
        let year = this.getBirthShortYear();
        switch (Number(this.id.charAt(0))) {
            case 1:
            case 2:
                year += 1800;
                break;
            case 3:
            case 4:
                year += 1900;
                break;
            case 5:
            case 6:
                year += 2000;
                break;
            default: break;
        }
        return year;
    }
    getControlNumber() {
        return parseInt(this.id.charAt(10));
    }
    getAge(today = dayjs().toDate()) {
        return dayjs(today).diff(dayjs(this.getBirthdayDate()), 'years', false);
    }
    generateControlNumber() {
        const multiplier1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 1];
        const multiplier2 = [3, 4, 5, 6, 7, 8, 9, 1, 2, 3];
        let mod;
        let total = 0;
        for (let i = 0; i < 10; i++) {
            total += parseInt(this.id.charAt(i)) * multiplier1[i];
        }
        mod = total % 11;
        total = 0;
        if (mod === 10) {
            for (let i = 0; i < 10; i++) {
                total += parseInt(this.id.charAt(i)) * multiplier2[i];
            }
            mod = total % 11;
            if (mod === 10)
                mod = 0;
        }
        return mod;
    }
}
exports.EEPersonalId = EEPersonalId;
